import React, { useState } from 'react';
import { Col, Row } from '../../lib/utils';
import { MediumText, RegularText } from '../../lib/Text';
import RappoPayHistoryPage from './RappoPayHistoryPage';
import RappoPayDocumentsPage from './RappoPayDocumentsPage';
import BusinessInfoFooter from '../../components/BusinessInfoFooter';

type TabType = 'rappoPayHistory' | 'rappoPayDocuments';

const tabs: { title: string; key: TabType }[] = [
    { title: '라포페이 내역', key: 'rappoPayHistory' },
    { title: '라포페이 서류 설정', key: 'rappoPayDocuments' },
];

const RappoPayPage = () => {
    const [selectedTab, setSelectedTab] = useState<TabType>('rappoPayHistory');

    return (
        <Col className="flex flex-col w-full max-w-[1200px] mx-auto pt-[128px] px-[40px]">
            {/* 탭 헤더 */}
            <Row className="flex items-center mb-[33px]">
                {tabs.map((tab) => (
                    <Col
                        key={tab.key}
                        className="mr-[42px] cursor-pointer"
                        onClick={() => setSelectedTab(tab.key)}
                    >
                        <MediumText
                            fontSize={25}
                            lineHeight={32}
                            color={selectedTab === tab.key ? '#3D4244' : '#B6B8BA'}
                            className="mb-[8px]"
                        >
                            {tab.title}
                        </MediumText>
                        {selectedTab === tab.key && <div className="w-full h-[5px] bg-[#3D4244]" />}
                    </Col>
                ))}
            </Row>

            {/* 탭 콘텐츠 */}
            {selectedTab === 'rappoPayHistory' && <RappoPayHistoryPage />}
            {selectedTab === 'rappoPayDocuments' && <RappoPayDocumentsPage />}

            {/* 사업자 정보 (카드사 심사용) */}
            <div style={{ width: '100%', marginTop: 80 }}>
                <BusinessInfoFooter />
            </div>
        </Col>
    );
};

export default RappoPayPage;
